export const companyInfo = {
  name: '우진에코텍주식회사',
  established: '2003년',
  ceo: '대표이사',
  address: '강원도 홍천군 화촌면 송정2길9',
  phone: '033-435-2696',
  fax: '033-435-2199',
  email: 'seok8131@naver.com'
};

export const businessAreas = [
  {
    icon: 'ri-box-3-line',
    title: '매트리스개비온 제조',
    description: '고품질 매트리스개비온 전문 생산'
  },
  {
    icon: 'ri-water-flash-line',
    title: '하천 호안 보호 구조물',
    description: '하천 침식 방지 및 호안 안정화 솔루션'
  },
  {
    icon: 'ri-shield-line',
    title: '침식 방지 솔루션',
    description: '다양한 현장 조건에 맞는 침식 방지 시스템'
  },
  {
    icon: 'ri-settings-3-line',
    title: '현장 맞춤 적용',
    description: '현장 특성을 고려한 맞춤형 설계 및 시공'
  }
];

export const companyStrengths = [
  {
    number: '30+',
    label: '년 이상의 현장 경험',
    description: '다양한 하천정비 프로젝트 수행'
  },
  {
    number: '300+',
    label: '개 이상의 프로젝트',
    description: '전국 주요 하천정비 사업 참여'
  },
  {
    number: '100%',
    label: '품질 보증',
    description: '엄격한 품질관리 시스템 운영'
  }
];

export const technicalPrinciples = [
  {
    title: '구조적 안정성',
    description: '매트리스개비온의 유연한 구조는 지반 변형에 대응하며, 하중을 균등하게 분산시켜 장기적인 안정성을 확보합니다.',
    image: 'https://public.readdy.ai/ai/img_res/de792dc3d060775fa547a0f89c33b002.jpg'
  },
  {
    title: '침식 방지 원리',
    description: '석재 충진 구조가 수류의 에너지를 흡수하고 분산시켜 하천 바닥과 호안의 침식을 효과적으로 방지합니다.',
    image: 'https://readdy.ai/api/search-image?query=Technical%20illustration%20of%20erosion%20prevention%20mechanism%20with%20water%20flow%20arrows%20and%20gabion%20mattress%20protection%2C%20engineering%20diagram%2C%20cross-sectional%20view%2C%20professional%20technical%20drawing%2C%20educational%20schematic%2C%20clean%20background&width=600&height=400&seq=tech2&orientation=landscape'
  },
  {
    title: '친환경 생태 기능',
    description: '석재 사이의 공극은 수생 생물의 서식처를 제공하며, 식생 활착을 촉진하여 자연 생태계 복원에 기여합니다.',
    image: 'https://readdy.ai/api/search-image?query=Ecological%20function%20diagram%20showing%20gabion%20mattress%20with%20aquatic%20plants%20growing%20through%20stones%2C%20fish%20habitat%20spaces%2C%20environmental%20harmony%20illustration%2C%20technical%20drawing%20with%20nature%20elements%2C%20educational%20diagram&width=600&height=400&seq=tech3&orientation=landscape'
  }
];
